/**
 * Форматласан тоог «гүйлгэж» харуулна — `CountUp text="160.9 сая₮"`.
 *
 * Оролт нь @boots/domain-ий форматтерын ГАРАЛТ (`formatMntShort`,
 * `formatQty`, `formatMnt`, `formatRate`). Эхний тоон хэсгийг салгаж,
 * завсрын утгыг МӨН domain-ий форматтероор бичнэ — аравтын оронтой бол
 * `formatRate(n, d)`, бүхэл бол `formatQty(n)`. Гар формат байхгүй
 * (CLAUDE.md дүрэм 14).
 *
 * Тоогүй мөр («—», «•••») өөрчлөгдөхгүй гарна.
 *
 * Дэлгэц уншигч завсрын утгыг сонсохгүй — эцсийн мөр `sr-only`-д.
 */

import { formatQty, formatRate } from '@boots/domain';
import { useTween } from '../lib/use-tween';

const LEADING_NUMBER = /^(-?)(\d[\d,]*(?:\.\d+)?)(.*)$/s;

function parse(text: string): { n: number; decimals: number; rest: string } | null {
  const m = LEADING_NUMBER.exec(text);
  if (!m) return null;
  const [, sign = '', body = '', rest = ''] = m;
  const n = Number(body.replace(/,/g, '')) * (sign ? -1 : 1);
  return { n, decimals: body.split('.')[1]?.length ?? 0, rest };
}

export function CountUp({
  text,
  duration = 1400,
  unitClassName,
}: {
  text: string;
  duration?: number;
  /** Өгвөл нэгжийг («сая₮», «₽») тусад нь жижиг бичнэ. Үгүй бол тоотой нэг мөрөнд. */
  unitClassName?: string;
}) {
  const parsed = parse(text);
  const v = useTween(parsed?.n ?? 0, duration);
  if (!parsed) return <>{text}</>;

  const shown = parsed.decimals > 0 ? formatRate(v, parsed.decimals) : formatQty(v);
  const unit = parsed.rest.trim();

  return (
    <>
      <span className="sr-only">{text}</span>
      <span aria-hidden className="num">{shown}</span>
      {unit ? (
        <span aria-hidden className={unitClassName}>
          {unitClassName ? unit : parsed.rest}
        </span>
      ) : null}
    </>
  );
}
